<template>
    <div class="poi-info" :class="{'poi-info--poi--partner' : poi.isPartner}">
        <el-collapse v-model="activeItem" @change="collapseChangeHandler" class="poi-info__list">

            <!-- Road Information -->
            <ListInfoItem v-if="poi.roadInformation" :has-content="true" :centerVertically="true">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconInfo /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title list-info-item__summary__title--margin-top list-info-item__summary__title--margin-bottom">Allgemeine Informationen</div>
                        <div></div>
                    </div>
                </template>
                <template slot="content">
                    <div class="list-info-item__section">
                        <div class="list-info-item__row list-info-item__row--more-space copy-light ui-spread" v-if="poi.roadInformation.altitude">
                            <span>Seehöhe</span>
                            <span>{{ poi.roadInformation.altitude }} m</span>
                        </div>
                        <div class="list-info-item__row list-info-item__row--more-space copy-light ui-spread" v-if="poi.roadInformation.fall">
                            <span>Steigung</span>
                            <span>{{ poi.roadInformation.fall }} %</span>
                        </div>
                        <div class="list-info-item__row list-info-item__row--more-space copy-light ui-spread" v-if="poi.roadInformation.camperAllowed !== undefined">
                            <span>Eignung für Wohnwagen</span>
                            <span>{{ poi.roadInformation.camperAllowed ? 'Ja' : 'Nein' }}</span>
                        </div>
                        <div class="list-info-item__row list-info-item__row--more-space copy-light ui-spread" v-if="poi.roadInformation.tunnelLength">
                            <span>Länge</span>
                            <span>{{ poi.roadInformation.tunnelLength }} m</span>
                        </div>
                        <div class="list-info-item__row list-info-item__row--more-space copy-light ui-spread" v-if="poi.roadInformation.pipes">
                            <span>Anzahl der Röhren</span>
                            <span>{{ poi.roadInformation.pipes }}</span>
                        </div>
                        <div class="list-info-item__row list-info-item__row--more-space copy-light ui-spread" v-if="poi.roadInformation.toll !== undefined">
                            <span>Mautpflicht</span>
                            <span>{{ poi.roadInformation.toll ? 'Ja' : 'Nein' }}</span>
                        </div>
                    </div>
                </template>
            </ListInfoItem>

            <!-- Road From-To -->
            <ListInfoItem v-if="poi.roadFromTo" :has-content="true" :centerVertically="true">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconStreet /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">Streckenverlauf</div>
                    </div>
                </template>
                <template slot="content">
                    <div class="list-info-item__section">
                        <div class="list-info-item__row copy-light">
                            {{ poi.roadFromTo }}
                        </div>
                    </div>
                </template>
            </ListInfoItem>
         
            <!-- Public Transport Connection -->
            <ListInfoItem type="collapse" v-if="poi.publicTransportConnection" collapse-name="nearbyStationsItem" :content-full-width="true" class="poi-info__wrap-visible">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconPublicTransport /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">Haltestellen in der Nähe</div>
                        <div class="list-info-item__summary__text copy-light">Haltestellenmonitor aufrufen</div>
                    </div>
                </template>
                <template slot="content">
                    <NearbyStationsList :coordinates="poi.coordinates" ref="nearbyStationsList" :parentPoi="parentPoiData" />
                </template>
            </ListInfoItem>

            <!-- Company -->
            <ListInfoItem v-if="poi.company && poi.company.name" :overflowGradient="false">
                <template slot="summary">
                    <img class="list-info-item__summary__image" :src="poi.company.image" />
                    <div class="list-info-item__summary__texts list-info-item__summary__texts--expand">
                        <div class="ui-spread-center-vertically">
                            <div>
                                <div class="list-info-item__summary__title h4">
                                    {{ poi.company.name }}
                                </div>
                                <div class="list-info-item__summary__text list-info-item__summary__text--wrap copy-light">
                                    Betreiber
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </ListInfoItem>

            <!-- Detail Name -->
            <ListInfoItem v-if="poi.detailName && poi.detailName.name" :overflowGradient="false">
                <template slot="summary">
                    <icon v-if="poi.detailName.icon" class="list-info-item__summary__icon">
                        <POIIcon :icon="poi.detailName.icon" />
                    </icon>
                    <img v-else-if="poi.detailName.image" class="list-info-item__summary__image" :src="poi.detailName.image" />
                    <div class="list-info-item__summary__texts list-info-item__summary__texts--expand">
                        <div class="ui-spread-center-vertically">
                            <div>
                                <div class="list-info-item__summary__title h4">
                                    {{ poi.detailName.name }}
                                </div>
                                <div class="list-info-item__summary__text list-info-item__summary__text--wrap copy-light">
                                    Name
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </ListInfoItem>
            <!-- Comments -->
            <ListInfoItem :overflowGradient="false" :hasIcon="false" :has-content="true" :centerVertically="true" v-if="poi.comments && poi.comments.content">
                <template slot="content">
                    <div class="copy-light" v-html="poi.comments.content"></div>
                </template>
            </ListInfoItem>
            <!-- Standorte operator comment -->
            <ListInfoItem :overflowGradient="false" :hasIcon="false" :has-content="true" :centerVertically="true" v-if="poi.operator && poi.operator.comments">
                <template slot="content">
                    <div v-for="(comment, index) in poi.operator.comments" :key="index" class="copy-light" v-html="comment.content"></div>
                </template>
            </ListInfoItem>
            <!-- Opening hours -->
            <ListInfoItem type="collapse" :collapseHideSummaryText="poi.todayMaxOpeningHours !== undefined" :centerVertically="!poi.todayMaxOpeningHours" v-if="poi.openingSections && (poi.openingSections.sections.length || poi.openingSections.comments.length)" :tooltips="tooltipsContent">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconClock /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">{{ poi.openingSections.title ? poi.openingSections.title : 'Öffnungszeiten' }}</div>
                        <div class="list-info-item__summary__text copy-light" v-if="poi.todayMaxOpeningHours">
                            {{ poi.todayMaxOpeningHours.label }} 
                            <span v-for="(hour,index) in poi.todayMaxOpeningHours.hours" :key="hour">
                                {{ hour }} 
                                <span v-if="index + 1 < poi.todayMaxOpeningHours.hours.length"> & </span> 
                            </span> 
                        </div>
                    </div>
                </template>
                <template slot="content">
                    <template v-if="poi.openingSections.sections.length">
                        <div class="list-info-item__section" v-for="section in poi.openingSections.sections" :key="section.label">
                            <div class="list-info-item__row copy">{{section.label}}</div>
                            <div class="list-info-item__row copy-light ui-spread" v-for="openingRow in section.openingHours" :key="openingRow.label">
                                <span>{{openingRow.label}}</span>
                                <span class="ui-text-right">
                                    <div v-for="hour in openingRow.hours" :key="hour">{{ hour }}</div>
                                </span>
                            </div>
                        </div>
                    </template>
                    <div v-if="poi.openingSections.comments.length" class="list-info-item__section">
                        <div v-for="(comment, index) in poi.openingSections.comments" :key="index" class="list-info-item__row copy-light">{{ comment.content }}</div>
                    </div>
                </template>
            </ListInfoItem>

            <!-- Plugs Types -->
            <ListInfoItem type="static" :centerVertically="true" :has-content="true" :overflowGradient="false" v-if="poi.plugTypes && poi.plugTypes.length">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconChargingPoint /></icon>
                    <div class="list-info-item__summary__texts list-info-item__summary__texts--expand ui-spread-center-vertically">
                        <div class="list-info-item__summary__title">Ladepunkte</div>
                        <img class="list-info-item__summary__infoimage" :src="`${publicPath}/images/logos/econtrol.svg`" alt="E-control">
                    </div>
                </template>
                <template slot="content">
                    <div class="list-info-item__section list-info-item__section--small-margin-bottom" :class="{ 'list-info-item__section--margin-top' : index === 0 }" v-for="(plug, index) in poi.plugTypes" :key="index">
                        <div class="list-info-item__row ui-spread">
                            <div class="ui-center-vertically">
                                <icon class="list-info-item__row__icon" :size="mobile ? 40 : 24">
                                    <PlugIcon :icon="plug.icon" />
                                </icon>
                                <div>
                                    <div class="copy">{{ plug.name }}</div>
                                    <div class="copy-light">{{ plug.kW }} kW</div>
                                </div>
                            </div>
                            <div class="copy-light">{{ plug.amount }} x</div>
                        </div>
                    </div>
                </template>
            </ListInfoItem>


            <!-- Parking Spaces -->
            <ListInfoItem :type="poi.parkingSpaces.default.length > 1 ? 'collapse' : 'static'" :collapseHideSummaryText="true" :overflowGradient="false" v-if="poi.parkingSpaces && poi.parkingSpaces.default && poi.parkingSpaces.default.length">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconParking /></icon>
                    <div class="list-info-item__summary__texts list-info-item__summary__texts--expand">
                        <div class="list-info-item__summary__title">Stellplätze</div>
                        <div class="list-info-item__summary__text copy-light ">
                            <span>{{ poi.parkingSpaces.default[0].label }}</span>
                            <span v-if="poi.parkingSpaces.default[0].amount && poi.parkingSpaces.default[0].amount > 1" class="dot-divider dot-divider--light">{{ poi.parkingSpaces.default[0].amount }}</span>
                            <span class="ui-nowrap dot-divider dot-divider--light" :class="poi.availability.color" v-if="poi.availability">{{poi.availability.label}}</span>
                        </div>
                    </div>
                </template>
                <template slot="content" v-if="poi.parkingSpaces.default.length > 1">
                    <div class="list-info-item__row copy-light ui-spread-center-vertically" v-for="(parkingRow, index) in poi.parkingSpaces.default" :key="parkingRow.label">
                        <div class="ui-center-vertically">
                            {{ parkingRow.label }}
                            <span v-if="parkingRow.amount && parkingRow.amount > 1" class="dot-divider dot-divider--light">{{ parkingRow.amount }}</span>
                        </div>
                        <span class="ui-nowrap" :class="poi.availability.color" v-if="index === 0 && poi.availability">{{poi.availability.label}}</span>
                    </div>
                </template>
            </ListInfoItem>

            <!-- Prices -->
            <ListInfoItem :type="poi.priceList.displayMode === 'list' ? 'static' : 'collapse'" :collapseHideSummaryText="true" :hasContent="!poi.priceList.hideContent" :centerVertically="poi.priceList.displayMode === 'list'" :contentSpaceTop="poi.priceList.displayMode === 'list'" v-if="poi.priceList && ((poi.priceList.sections.defaultItems && poi.priceList.sections.defaultItems.length) || (poi.priceList.sections.otherItems && poi.priceList.sections.otherItems.length) || poi.priceList.hideContent)">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconPrice /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">{{ poi.priceList.title }}</div>
                        <div class="list-info-item__summary__text copy-light" v-if="poi.mainPrice && poi.priceList.displayMode !== 'list'">{{ poi.mainPrice.label }} {{ poi.mainPrice.price }}</div>
                        <div class="list-info-item__summary__text copy-light" v-if="poi.priceList.subtitle">{{ poi.priceList.subtitle }}</div>
                    </div>
                </template>
                <template slot="content" v-if="!poi.priceList.hideContent">
                    <div class="list-info-item__section" v-for="(section, index) in poi.priceList.sections" :key="index">
                        <div class="list-info-item__row ui-spread" v-for="(priceRow, priceRowIndex) in section" :key="priceRowIndex" :class="poi.type === 'gasStations' ? 'copy' : 'copy-light'">
                            <span :class="{'caption-light' : priceRow.labelSmall}">{{priceRow.label}}</span>
                            <div class="ui-text-right ui-flex">
                                <span v-if="priceRow.updated" class="list-info-item__summary__infolabel caption-light">
                                    {{ priceRow.updated }}
                                </span>
                                <img class="list-info-item__summary__infoimage" v-if="priceRow.infoImage" :src="priceRow.infoImage" :alt="priceRow.label">
                                <SmrTooltip content="Kraftstoffpreis an ÖAMTC melden" position="bottom">
                                    <span v-if="priceRow.actionLabel" class="list-info-item__summary__action copy-bold" @click="emitEvent(priceRow.actionEvent)">
                                            {{ priceRow.actionLabel }}
                                    </span>
                                </SmrTooltip>
                                <span>{{ priceRow.price }}</span>
                            </div>
                        </div>
                    </div>
                    <template v-if="poi.priceList.comments && poi.priceList.comments.length">
                        <div class="list-info-item__section copy-light" v-for="(comment, index) in poi.priceList.comments" :key="index" v-html="comment.content"></div>
                    </template>
                </template>
            </ListInfoItem>

            <!-- Payment Options -->
            <ListInfoItem v-if="poi.paymentOptions && poi.paymentOptions.options && poi.paymentOptions.options.length" :centerVertically="poi.paymentOptions.hasComments" :hasContent="true">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconPayment /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">Zahlungsmöglichkeiten</div>
                        <div class="list-info-item__summary__texts copy-light" v-if="!poi.paymentOptions.hasComments">
                            <div v-for="option in poi.paymentOptions.options" :key="option.title">
                                {{ option.title }}
                            </div>
                        </div>
                    </div>
                </template>
                <template slot="content" v-if="poi.paymentOptions.hasComments">
                    <div class="list-info-item__section list-info-item__section--margin-top" v-for="option in poi.paymentOptions.options" :key="option.title">
                        <div class="list-info-item__row">
                            <div class="copy">{{ option.title }}</div>
                            <template v-if="option.comments">
                                <div v-for="(comment, commentIndex) in option.comments" :key="commentIndex" class="copy-light" v-html="comment.content"></div>
                            </template>
                        </div>
                    </div>
                </template>
            </ListInfoItem>

            <!-- Authentication -->
            <ListInfoItem v-if="poi.authentication && poi.authentication.length" :hasContent="false">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconCard /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">Authentifizierung</div>
                        <div class="list-info-item__summary__texts copy-light">
                            <div v-for="option in poi.authentication" :key="option.type">
                                {{ option.title }}
                            </div>
                        </div>
                    </div>
                </template>
            </ListInfoItem>

            <!-- Operation Mode -->
            <ListInfoItem v-if="poi.operationMode">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconGasStation /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">Betriebsart</div>
                        <div class="list-info-item__summary__text copy-light">{{poi.operationMode}}</div>
                    </div>
                </template>
            </ListInfoItem>

            <!-- Free Minutes -->
            <ListInfoItem :type="poi.freeMinutes.length > 1 ? 'collapse' : 'static'" :collapseHideSummaryText="true" v-if="poi.freeMinutes && poi.freeMinutes.length">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconClock /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">Freiminuten</div>
                        <div class="list-info-item__summary__text copy-light">
                            {{ poi.freeMinutes[0] }}
                        </div>
                    </div>
                </template>
                <template slot="content" v-if="poi.freeMinutes.length > 1">
                    <div class="list-info-item__row copy-light" v-for="freeMinutesRow in poi.freeMinutes" :key="freeMinutesRow">
                        <span>{{ freeMinutesRow }}</span>
                    </div>
                </template>
            </ListInfoItem>

            <!-- OEAMTC Partner description -->
            <ListInfoItem v-if="poi.partnerDescription" :overflow-gradient="false" :class="{ 'order-0' : poi.isPartner }">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconPercentage /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">ÖAMTC-Vorteilspartner</div>
                        <ContentExpand>
                            <div class="list-info-item__summary__text list-info-item__summary__text--wrap copy-light" v-for="(item, index) in poi.partnerDescription" :key="index" v-html="item.content"></div>
                        </ContentExpand>
                    </div>
                </template>
            </ListInfoItem>

            <!-- OECC Partner description -->
            <ListInfoItem v-if="poi.oeccPartnerDescription" :overflow-gradient="false">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconPercentage /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">ÖCC-Vorteil</div>
                        <ContentExpand>
                            <div class="list-info-item__summary__text list-info-item__summary__text--wrap copy-light" v-for="(item, index) in poi.oeccPartnerDescription" :key="index" v-html="item.content"></div>
                        </ContentExpand>
                    </div>
                </template>
            </ListInfoItem>


            <!-- Greenzone description -->
            <ListInfoItem v-if="poi.type === 'greenzone'" :overflow-gradient="false" :no-border="true">
                <template slot="summary">
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__text list-info-item__summary__text--wrap copy-light">
                            Mittlerweile gibt es in zahlreichen Städten Europas Umweltzonen, Fahrverbote und Zufahrtsbeschränkungen. 
                            Einheitliche Regelungen für die verschiedenen Zonen gibt es jedoch nicht. Von Fahrverboten zu bestimmten Uhrzeiten bis zu Plaketten, 
                            die an die Windschutzscheibe geklebt werden müssen, sind die Regelungen sehr unterschiedlich. 
                            Informieren Sie sich daher vor Ihrer Reise rechtzeitig über die aktuellen Bestimmungen und achten 
                            Sie bei der Einfahrt in die Stadtzentren auf eventuelle Hinweisschilder oder Leuchttafeln.
                            <span v-if="poi.additionalLink">
                                <br><br>
                                Weitere Infos: <a :href="poi.additionalLink.link" target="_blank">{{ poi.additionalLink.title }}</a>
                            </span>
                        </div>
                    </div>
                </template>
            </ListInfoItem>

            <!-- Opening seasons -->
            <ListInfoItem :type="poi.openingSeasons.list ? 'collapse' : 'static'" :collapseHideSummaryText="true" v-if="poi.openingSeasons">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconClock /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">Öffnungszeiten</div>
                        <div class="list-info-item__summary__text copy-light">{{ poi.openingSeasons.current }}</div>
                    </div>
                </template>
                <template slot="content" v-if="poi.openingSeasons.list">
                    <div class="list-info-item__row copy-light" v-for="season in poi.openingSeasons.list" :key="season">{{season}}</div>
                </template>
            </ListInfoItem>

            <!-- Maximum Height -->
            <ListInfoItem v-if="poi.maximumHeight && poi.maximumHeight.length">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconMaxHeight /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">Einfahrtsbeschränkung</div>
                        <div class="list-info-item__summary__text copy-light">
                            Max. Höhe {{ poi.maximumHeight }}
                        </div>
                    </div>
                </template>
            </ListInfoItem>

            <!-- Accessibility -->
            <ListInfoItem v-if="poi.accessibility && poi.accessibility.isAccessible" :overflow-gradient="false">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconWheelchair /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">Barrierefreiheit</div>
                        <div class="list-info-item__summary__text list-info-item__summary__text--wrap copy-light">
                            <div v-if="poi.accessibility.handicappedParking">
                                <span v-if="poi.accessibility.handicappedParkingLots">{{ poi.accessibility.handicappedParkingLots }} Behindertenparkplätze</span>
                                <span v-else>Barrierefreie Parkplätze vorhanden</span>
                                <template v-if="poi.accessibility.handicappedParkingComments" >
                                    <span v-for="(comment, index) in poi.accessibility.handicappedParkingComments" :key="index" v-html="comment.content"></span>
                                </template>
                            </div>
                            <div v-else-if="poi.accessibility.isAccessible">
                                <span>Barrierefreier Zugang</span>
                                <template v-if="poi.accessibility.accessibleComments" >
                                    <span v-for="(comment, index) in poi.accessibility.accessibleComments" :key="index" v-html="comment.content"></span>
                                </template>
                            </div>
                        </div>
                    </div>
                </template>
            </ListInfoItem>

            <!-- Electric Car Info -->
            <ListInfoItem v-if="poi.parkingSpaces && poi.parkingSpaces.electricCar">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconEStation /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">Service E-Autos</div>
                        <div class="list-info-item__summary__text copy-light">
                            <div v-if="poi.parkingSpaces.electricCar.amount && poi.parkingSpaces.electricCar.amount > 1">{{ poi.parkingSpaces.electricCar.amount }} E-Auto Stellplätze</div>
                            <div v-else>E-Auto Stellplätze vorhanden</div>
                        </div>
                    </div>
                </template>
            </ListInfoItem>

            <!-- Additional Information -->
            <ListInfoItem v-if="poi.additionalInformation && poi.additionalInformation.text && poi.additionalInformation.text.length > 0" :hasContent="true" :centerVertically="true">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconInfo /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title" v-html="poi.additionalInformation.title"></div>
                    </div>
                </template>
                <template slot="content">
                    <div class="list-info-item__section"  v-for="(info, index) in poi.additionalInformation.text" :key="index">
                        <div class="list-info-item__row copy-light">
                            <span v-html="info.content"></span>
                        </div>
                    </div>
                    <ContentExpand v-if="poi.additionalInformation.expandableText && poi.additionalInformation.expandableText.length > 0" :moreText="poi.additionalInformation.showMoreText" :lessText="poi.additionalInformation.hideMoreText" :collapsedHeight="'0px'">
                        <div class="list-info-item__section"  v-for="(info, index) in poi.additionalInformation.expandableText" :key="index">
                            <div class="list-info-item__row">
                                <div class="copy black" v-if="info.title" v-html="info.title"></div>
                                <span class="copy-light" v-html="info.content"></span>
                            </div>
                        </div>
                    </ContentExpand>
                </template>
            </ListInfoItem>

            <!-- Phone -->
            <ListInfoItem :href="mobile ? `tel:${poi.phone.replace(/\s/g, '')}` : false" v-if="poi.phone">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconPhone /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">{{ poi.phone }}</div>
                        <div class="list-info-item__summary__text copy-light"><template v-if="mobile">Jetzt anrufen</template><template v-else>Telefonnummer</template></div>
                    </div>
                </template>
            </ListInfoItem>

            <!-- Email -->
            <ListInfoItem :href="`mailto:${poi.email}`" v-if="poi.email">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconEmail /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">{{ poi.email }}</div>
                        <div class="list-info-item__summary__text copy-light">E-Mail schreiben</div>
                    </div>
                </template>
            </ListInfoItem>

            <!-- Operator -->
            <ListInfoItem v-if="poi.operator && poi.operator.name" :overflowGradient="false">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon" v-if="poi.operator.spaceLeft"></icon>
                    <div class="list-info-item__summary__texts list-info-item__summary__texts--expand">
                        <div class="ui-spread-center-vertically">
                            <div>
                                <div class="list-info-item__summary__title h4">Betreiber</div>
                                <div class="list-info-item__summary__text list-info-item__summary__text--wrap copy-light">
                                    {{ poi.operator.name }}
                                </div>
                            </div>
                            <img class="list-info-item__summary__infoimage list-info-item__summary__infoimage--wide" v-if="poi.operator.imageUrl" :src="poi.operator.imageUrl" :alt="poi.operator.name">
                        </div>
                    </div>
                </template>
            </ListInfoItem>

            <!-- Website -->
            <ListInfoItem :href="poi.website" v-if="poi.website"  :overflow-gradient="false">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconWebsite /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title list-info-item__summary__title--break">{{ poi.website | formatUrl }}</div>
                        <div class="list-info-item__summary__text copy-light">Webseite besuchen</div>
                    </div>
                </template>
            </ListInfoItem>


            <!-- Services -->
            <ListInfoItem v-if="poi.services && poi.services.length">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title">Services</div>
                        <div class="list-info-item__summary__text copy-light">
                            <div v-for="service in poi.services" :key="service">{{ service }}</div>
                        </div>
                    </div>
                </template>
            </ListInfoItem>

            <!-- Additional texts -->
            <ListInfoItem v-if="poi.texts" :has-content="true">
                <template slot="content">
                    <div class="list-info-item__section" v-for="text in poi.texts" :key="text.title">
                        <div class="list-info-item__row copy" v-if="text.title">{{ text.title }}</div>
                        <div class="list-info-item__row copy-light">
                            <span v-for="content in text.content" :key="content" v-html="content"></span>
                        </div>
                    </div>
                </template>
            </ListInfoItem>

            <!-- Validity -->
            <ListInfoItem v-if="poi.validity">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconCalendar /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title h4">Gültigkeit</div>
                        <div class="list-info-item__summary__text copy-light">
                            Beginn: {{ poi.validity.start }}
                            <br>
                            Ende: {{ poi.validity.end }}
                        </div>
                    </div>
                </template>
            </ListInfoItem>

            <!-- Source -->
            <ListInfoItem v-if="poi.source">
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title h4">Quelle</div>
                        <div class="list-info-item__summary__text copy-light">
                            {{ poi.source }}
                        </div>
                    </div>
                </template>
            </ListInfoItem>

            <!-- PDF Download -->
            <ListInfoItem :href="poi.pdf.link" v-if="poi.pdf"  :overflow-gradient="false" download>
                <template slot="summary">
                    <icon class="list-info-item__summary__icon"><IconPdf /></icon>
                    <div class="list-info-item__summary__texts">
                        <div class="list-info-item__summary__title list-info-item__summary__title--break">{{ poi.pdf.title }}</div>
                        <div class="list-info-item__summary__text copy-light">PDF herunterladen</div>
                    </div>
                </template>
            </ListInfoItem>
        </el-collapse>

        <div class="poi-info__actions" :class="{'poi-info__actions--spacing-bottom' : poi.type === 'gasStations'}">
            <div class="sidebar__section">
                <SmrTooltip v-if="poi.type === 'gasStations'" content="Fehler in Tankstellen-Daten melden" position="top">
                    <SmrButton :href="feedbackLink" color="grey" tag="a">
                        Daten berichtigen
                    </SmrButton>
                </SmrTooltip>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatUrl } from '@/utils/format';
import eventBus from '@/utils/event-bus';
import ListInfoItem from '@/components/ListInfoItem.vue'
import ContentExpand from '@/components/ContentExpand.vue'
import SmrButton from '@/components/SmrButton.vue'
import SmrTooltip from '@/components/SmrTooltip.vue'
import Icon from '@/components/Icon.vue'
import IconClock from '@/components/icons/IconClock.vue'
import IconPhone from '@/components/icons/IconPhone.vue'
import IconEmail from '@/components/icons/IconEmail.vue'
import IconWebsite from '@/components/icons/IconWebsite.vue'
import IconCalendar from '@/components/icons/IconCalendar.vue'
import IconPrice from '@/components/icons/IconPrice.vue'
import IconPayment from '@/components/icons/IconPayment.vue'
import IconMaxHeight from '@/components/icons/IconMaxHeight.vue'
import IconWheelchair from '@/components/icons/IconWheelchair.vue'
import IconParking from '@/components/icons/IconParking.vue'
import IconEStation from '@/components/icons/IconEStation.vue'
import IconPercentage from '@/components/icons/IconPercentage.vue'
import IconPublicTransport from '@/components/icons/IconPublicTransport.vue'
import IconGasStation from '@/components/icons/IconGasStation.vue'
import IconInfo from '@/components/icons/IconInfo.vue'
import IconPdf from '@/components/icons/IconPdf.vue'
import IconStreet from '@/components/icons/IconStreet.vue'
import IconChargingPoint from '@/components/icons/IconChargingPoint.vue'
import IconCard from '@/components/icons/IconCard.vue'
import POIIcon from '@/components/POIIcon.vue'
import PlugIcon from '@/components/PlugIcon.vue'

export default {
    components: {
        ListInfoItem,
        ContentExpand,
        SmrButton,
        SmrTooltip,
        Icon,
        IconClock,
        IconPhone,
        IconEmail,
        IconWebsite,
        IconCalendar,
        IconPrice,
        IconPayment,
        IconMaxHeight,
        IconWheelchair,
        IconParking,
        IconEStation,
        IconPercentage,
        IconPublicTransport,
        IconGasStation,
        IconInfo,
        IconPdf,
        IconStreet,
        IconChargingPoint,
        IconCard,
        POIIcon,
        PlugIcon,
        NearbyStationsList: () => import(/* webpackChunkName: "NearbyStationsList" */ '@/components/NearbyStationsList.vue'),
    },
    props: {
        poi: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            publicPath: process.env.BASE_URL,
            activeItem: null,
            tooltipsContent: {
                content: 'Mehr anzeigen',
                position: 'bottom',
                closed: 'Weniger Anzeigen',
            }
        }
    },
    mounted() {
        if (this.isNearbyStationsListOpen) {
            this.activeItem = 'nearbyStationsItem'
        }
    },
    computed: {
        ...mapGetters(['mobile', 'isNearbyStationsListOpen']),
        feedbackLink() {
            let link = '';
            if(this.poi.type === 'gasStations') {
                const mailBody = `ID der Tankstelle: ${this.poi.id}%0D%0AName: ${this.poi.title}%0D%0AIhre Berichtigung: %0D%0AWeb-Version: ${process.env.VUE_APP_VERSION}`
                link = `mailto:benzinpreis@oeamtc.at?subject=Datenberichtigung&body=${mailBody}`
            }
            return link
        },
        parentPoiData() {
            return {
                id: this.poi.id,
                type: this.poi.type,
                subType:this.poi.subType,
                showingMapPins: true,
            }
        }
    },
    filters: {
        formatUrl(url) {
            return formatUrl(url)
        },
    },
    methods: {
        emitEvent(event) {
            if(!event) return
            if(this.poi.type === 'gasStations') eventBus.$emit(event, this.poi.priceList)
            eventBus.$emit(event)
        },
        collapseChangeHandler(openedCollapseItems) {
            if(openedCollapseItems.length && openedCollapseItems[openedCollapseItems.length - 1] === 'nearbyStationsItem') {
                this.$store.commit('setIsNearbyStationsListOpen', true)
                this.$refs['nearbyStationsList'].$emit('open-accordion');
            } else if (this.isNearbyStationsListOpen && !openedCollapseItems.includes('nearbyStationsItem')) {
                this.$store.commit('setIsNearbyStationsListOpen', false)
                this.$refs['nearbyStationsList'].$emit('close-accordion');
            }
        }
    }
}
</script>

<style lang="scss">
.poi-info {
    $block: &;

    &--poi {
        &--partner {
            #{$block}__list {
                display: flex;
                flex-direction: column;

                & > * {
                    order: 1;

                    &.order-0 {
                        order: 0;
                    }
                }
            }
        }
    }

    &__wrap-visible {
        .el-collapse-item__wrap {
            overflow: visible;
        }
    }

    &__actions {
       margin-top: 32px; 
       &--spacing-bottom {
           margin-bottom: 32px;
       }
    }
}
</style> 